var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#222",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M38.43 13.8H9.57A2.57 2.57 0 0 0 7 16.37v18.86a2.57 2.57 0 0 0 2.57 2.57h28.86A2.57 2.57 0 0 0 41 35.23V16.37a2.57 2.57 0 0 0-2.57-2.57ZM13.45 13.8v24.02"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#222",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M22.3 27.34a3.8 3.8 0 0 0 5.41 4.38 29 29 0 0 0 2.62-2c.92-.62 2.29-.88 3.06-.08.298.378.507.82.61 1.29l.89 3.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7900",
    d: "m37.92 9.38-14 14a.8.8 0 0 0-.18.27l-.79 2a.12.12 0 0 0 .16.16l2-.79q.143-.066.26-.17l14-14a1.1 1.1 0 0 0 .09-1.59 1.1 1.1 0 0 0-1.54.12"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6 9h36v29.82H6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArts);
export default __webpack_public_path__ + "static/media/arts.6fd81592bafdd2ddf6de2ac4b36b4c4a.svg";
export { ForwardRef as ReactComponent };